<template>
  <div class="container">
	  <div class="loginContent">
		  <div class="w1600">
			<div class="registerForm">
				<!-- 1-2 -->
				<div class="loginForm p3 bd10" v-show="showContent == 1">
						<h3 class="font28">{{$t("register.title")}}</h3>
						<p class="font18 font-light tip cor999">{{$t("register.titleTip")}}</p>
						<!-- 1 -->
						<div class="rgStep1" v-show="showStep == 1">
							<div class="form">
								<dl>
									<dd class="d-flex f-colu">
										<div class="label font-medium">{{$t("commom.email")}}</div>
										<div class="enter d-flex code">
											<input type="text" v-model="formData.email" class="input font-light" :placeholder="$t('commom.emailPlaceholder')">
											<button class="fmBtn pointer font-light" @click="getCode">{{codeText}}</button>
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="label font-medium">{{$t("commom.code")}}</div>
										<div class="enter">
											<input type="text" v-model="formData.code" maxlength="6" class="input font-light" :placeholder="$t('commom.codePlaceholder')">
										</div>
									</dd>
								</dl>
							</div>
							<div class="submit d-flex j-sb">
								<button class="fmBtn font20 font-medium pointer" @click="nextSetp">{{$t("register.nextSetp")}}</button>
								<button class="fmBtn font20 font-medium pointer back" @click="goToPage('/login')">{{$t("register.backLogin")}}</button>
							</div>
						</div>
						<!-- 2 -->
						<div class="rgStep2" v-show="showStep == 2">
							<div class="form">
								<dl>
									<dd class="d-flex f-colu">
										<div class="label font-medium">{{$t("register.siteId")}}<tip></tip></div>
										<div class="enter d-flex">
											<input type="text" v-model="formData.siteId" class="input font-light" :placeholder="$t('register.siteIdPlaceholder')">
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="label font-medium">{{$t("commom.password")}}<tip></tip></div>
										<div class="enter">
											<input type="password" v-model="formData.password" class="input font-light" :placeholder="$t('commom.passwordPlaceholder')">
										</div>
										<div class="passwordLevel d-flex" v-if="formData.password" :class="passwordLevel">
											<div class="lv d-flex"><i></i><i></i><i></i></div>
											<div class="lt"><span>弱</span><span>中</span><span>强</span></div>
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="label font-medium">{{$t("commom.confirmPassword")}}</div>
										<div class="enter">
											<input type="password" v-model="formData.confirmPassword" class="input font-light" :placeholder="$t('commom.confirmPassword')">
										</div>
									</dd>
								</dl>
							</div>
							<div class="submit d-flex f-colu">
								<button class="fmBtn font20 w100 font-medium pointer" @click="perfectInfo">{{$t("register.improveInformation")}}</button>
								<!-- <p class="d-flex j-end">{{$t("register.noSiteId")}}？<a class="pointer" @click="goToPage('/applyForTest')">{{$t("register.tRIAL")}}</a></p> -->
							</div>
						</div>
				</div>
				
				<!-- 3.完善个人资料 -->
				<div class="loginForm p3 bd10" v-show="showContent == 2">
						<p class="goLogin d-flex j-end cor999">{{$t("register.loginTip")}}<a @click="goToPage('/login')" class="pointer cor265 underline">{{$t("login.title")}}</a></p>
						<h3 class="font28">{{$t("register.improveInformation")}}</h3>
						<p class="font18 font-light tip cor999">{{$t("register.tRIALTip")}}</p>
						<div class="rgStep3">
							<div class="form">
								<dl>
									<dd class="d-flex f-colu">
										<div class="label font-medium">{{$t("register.company")}}<tip></tip></div>
										<div class="enter d-flex">
											<input type="text" v-model="perfectFormData.company" class="input font-light" :placeholder="$t('register.companyPlaceholder')">
										</div>
									</dd>
									<dd class="d-flex j-sb">
										<div class="item">
											<div class="label font-medium">{{$t("register.name")}}</div>
											<div class="enter">
												<input type="text" v-model="perfectFormData.name" class="input font-light" :placeholder="$t('register.namePlaceholder')">
											</div>
										</div>
										<div class="item">
											<div class="label font-medium">{{$t("register.surname")}}</div>
											<div class="enter">
												<input type="text" v-model="perfectFormData.sexual" class="input font-light" :placeholder="$t('register.surnamePlaceholder')">
											</div>
										</div>
									</dd>
									<dd class="d-flex j-sb">
										<div class="item">
											<div class="label font-medium">{{$t("register.country")}}</div>
											<div class="enter">
												<select v-model="perfectFormData.country" name="" id="" @change="getCurrentProvince" class="input font-light">
													<option value="">{{$t('register.countryPlaceholder')}}</option>
													<option :value="item.name" v-for="(item, index) in countryList" :key="index">{{item.name}}</option>
												</select>
											</div>
										</div>
										<div class="item">
											<div class="label font-medium">{{$t("register.province")}}</div>
											<div class="enter">
												<select v-model="perfectFormData.province" name="" id="" @change="getCurrentCity" class="input font-light">
													<option value="">{{$t('register.provincePlaceholder')}}</option>
													<option :value="item.name" v-for="(item, index) in provinceList" :key="index">{{item.name}}</option>
												</select>
											</div>
										</div>
									</dd>
									<dd class="d-flex j-sb">
										<div class="item">
											<div class="label font-medium">{{$t("register.city")}}</div>
											<div class="enter">
												<select v-model="perfectFormData.city" name="" id="" class="input font-light">
													<option value="">{{$t('register.cityPlaceholder')}}</option>
													<option :value="item.name" v-for="(item, index) in cityList" :key="index">{{item.name}}</option>
												</select>
											</div>
										</div>
										<div class="item">
											<div class="label font-medium">{{$t("register.encoded")}}</div>
											<div class="enter">
												<input type="text" v-model="perfectFormData.postalCode" class="input font-light" :placeholder="$t('register.encodedPlaceholder')">
											</div>
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="label font-medium">{{$t("register.address")}}</div>
										<div class="enter">
											<input type="text" v-model="perfectFormData.address" class="input font-light" :placeholder="$t('register.addressPlaceholder')">
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="label font-medium">{{$t("register.companyAddress")}}</div>
										<div class="enter">
											<input type="text" v-model="perfectFormData.companyAddress" class="input font-light" :placeholder="$t('register.companyAddressPlaceholder')">
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="label font-medium">{{$t("register.contact")}}</div>
										<div class="enter">
											<input type="text" v-model="perfectFormData.contact" class="input font-light" :placeholder="$t('register.contactPlaceholder')">
										</div>
									</dd>
									<!-- <dd class="d-flex f-colu">
										<div class="label font-medium">{{$t("register.interestedProduct")}}<tip></tip></div>
										<div class="interest">
											<ul class="d-flex f-wrap">
												<li :class="{active: productTag.indexOf(item.value)}" @click="addProductTag(item.value)" v-for="(item, index) in productTagList" :key="index">
													<p class="pointer font-light line-sm link"><span class="pr"></span>{{item.label}}</p>
												</li>
											</ul>
										</div>
									</dd> -->
								</dl>
							</div>
							<div class="submit d-flex">
								<button class="fmBtn font20 w100 font-medium pointer" @click="checkVerify">{{$t("register.improveInformation")}}</button>
							</div>
						</div>
						
				</div>
				<!-- 弹窗提示 -->
				<popup v-show="popupHandle">
					<div class="slot d-flex f-colu j-center a-center line-md">
						<img src="@/assets/Icons/error.png" alt="">
						{{message}}
					</div>
				</popup>
				<verify :show="showVerify" @success="handleVerify"></verify>
			</div>
		  </div>
	  </div>
  </div>
</template>

<script>
// 邮箱验证
let ruleEmail = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
export default {
  name: 'Register',
  data() {
    return {
		showContent: 1, //1.2步填写
		showStep: 1, // 完善个人资料
		codeNumber: 60, // 获取验证码读秒
		message: '', // 提示
		popupHandle: false, // 控制提示弹窗是否显示
		// 表单
		formData: {
			email: '', // 邮箱
			code: '', // 验证码
			siteId: '', // siteId
			password: '', // 密码
			confirmPassword: '', // 确认密码
		},
		sendStatus: true, // 验证码状态
		sendTimer: null, // 验证码定时器
		codeText: this.$t('commom.sendCode'), // 发送按钮文字
		// 完善资料表单
		perfectFormData: {
			code: '', // 效验码
			id: '', // 会员Id
			company: '', // 公司名称
			sexual: '', // 性别
			name: '', // 名称
			country: '', // 国家
			province: '', // 省份/州
			city: '', // 城市
			companyAddress: '', // 公司详细地址
			address: '', // 联系地址
			contact: '', // 联系方式
			postalCode: '', // 邮政编码
			productTag: '', // 感兴趣产品
		},
		productTag: [], // 感兴趣产品
		productTagList: [], // 感兴趣产品列表
		countryList: [], // 国家列表
		provinceList: [], // 省份列表
		cityList: [], // 城市列表
		passwordLevel:'',
		showVerify:false
		
	}
  },
  watch:{
	'formData.password':function(val) {
		this.passwordLevel='l'+this.checkPasswordStrength(val);
	}
  },
  created() {
	  // 获取国家
	  this.getCountryList();
  },
  
  
  methods: {
	checkVerify(){
		let that = this;
		that.showVerify=true;
	  },
	  handleVerify(){
		var that=this;
		that.showVerify=false;
		that.completeInfo();
	  },
	checkPasswordStrength(password) {
		let strength = 1;
		// 判断密码是否包含大小写字母和数字，且长度大于等于8位
		if (/[a-z]/.test(password) && /[A-Z]/.test(password) && /\d/.test(password) && password.length >= 8) {
			strength = 3;
		} else if (password.length >= 8||(/[a-z]/.test(password) && /[A-Z]/.test(password) && /\d/.test(password))) {
			strength = 2;
		}
		return strength;
	},
	  // 页面跳转
	  goToPage(path, query={}) {
		  this.$router.push({
			path,
			query
		  })
	  },
	  
	  /**
	   * 添加感兴趣产品
	   * @value 产品value
	   */
	  addProductTag(value) {
		  if(this.productTag.includes(value)) {
			  let index = this.productTag.indexOf(value);
			  this.productTag.splice(index, 1);
		  }else{
			  this.productTag.push(value);
		  }
	  },
	  
	  // 获取国家
	  getCountryList() {
		this.$axios.get(`common/select/country`)
		.then(res => {
			this.countryList = res.data;
		})
		.catch(err => {});
	  },
	  
	  // 根据选择国家显示对应省份
	  getCurrentProvince() {
		  // 清空省份城市
		  this.perfectFormData.province = '';
		  this.perfectFormData.city = '';
		  this.provinceList=[];
		  this.cityList=[];
		let current = this.countryList.filter(f => {return f.name == this.perfectFormData.country});
		this.$axios.get(`common/select/province?countryNo=${current[0].id}`)
		.then(res => {
			this.provinceList = res.data;
		})
		.catch(err => {});
	  },
	  
	  // 根据选择省份显示对应城市
	  getCurrentCity() {
	  		  // 清空城市
	  		  this.perfectFormData.city = '';
				this.cityList=[];
	  		let current = this.provinceList.filter(f => {return f.name == this.perfectFormData.province});
	  		this.$axios.get(`common/select/city?provinceNo=${current[0].id}`)
	  		.then(res => {
	  			this.cityList = res.data;
	  		})
	  		.catch(err => {});
	  },
	  
	  // 获取验证码
	  getCode() {
		  let that = this;
		  // 单独对邮箱进行验证
		  if (!ruleEmail.test(this.formData.email)) {
		    this.message = this.$t('commom.emailError');
		    this.popupHandle = true;
		    return;
		  }
		  if(this.sendStatus) {
			  this.sendStatus = false;
			  this.$axios.get(`verifyMember/sendEmailCode?email=${this.formData.email}`)
			  .then(res => {
				  this.$message({
				    message: this.$t('commom.sendSuccess'),
				    type: "success"
				  });
			  })
			  .catch(err => {});
			  this.sendTimer = setInterval(() => {
			    that.codeNumber--;
			    if (that.codeNumber <= 0) {
			      that.codeNumber = 60;
			      that.codeText = this.$t('commom.sendCode');
			      that.sendStatus = true;
			      clearInterval(that.sendTimer);
			    } else {
			      that.codeText = that.codeNumber + "s";
			    }
			  }, 1000);
		  }
	  },
	  
	  // 点击下一步
	  nextSetp() {
		  let that = this;
		  // 单独对邮箱进行验证
		  if (!ruleEmail.test(this.formData.email) || !this.formData.code.trim()) {
		    this.message = this.$t('commom.codeError');
		    this.popupHandle = true;
		    return;
		  }
		  this.$axios.get(`verifyMember/validateEmail?email=${this.formData.email}&code=${this.formData.code}`)
		  .then(res => {
			  let data = res.data;
			  this.formData.code = data.code;
			  // 进入 site id 页面
			  this.showStep = 2;
		  })
		  .catch(err => {});
		  
	  },
	  
	  // 完善个人信息
	  perfectInfo() {
		  let that = this;
		  if(!this.formData.siteId.trim()) {
			  this.message = this.$t('register.siteIdPlaceholder');
			  this.popupHandle = true;
			  return;
		  }
		  if(!this.formData.password.trim() || !this.formData.confirmPassword.trim()) {
			  this.message = this.$t('commom.passwordEmpty');
			  this.popupHandle = true;
			  return;
		  }
		  if(this.formData.password.trim().length<8) {
			  this.message = this.$t('commom.passwordLengthWram');
			  this.popupHandle = true;
			  return;
		  }
		  if(this.formData.password.trim() === this.formData.confirmPassword.trim()) {}else{
			  this.message = this.$t('commom.passwordNot');
			  this.popupHandle = true;
			  return;
		  }
		  let formData = new FormData();
		  // 遍历对象进行枚举
		  Object.keys(that.formData).forEach(function(key) {
		     formData.append(key, that.formData[key]);
		  });
		  this.$axios({
			  method: 'post',
			  url: 'verifyMember/improveSiteId',
			  headers: {'Content-Type':'multipart/form-data'},
			  data: formData
		  }).then(res => {
			  let data = res.data;
			  this.perfectFormData.id = data.id;
			  this.perfectFormData.code = data.code;
		  	this.showContent = 2;
		  })
		  .catch(err => {});
	  },
	  
	  // 确认完善信息
	  completeInfo() {
		   let that = this;
		  if(this.productTag.length) {
			  this.perfectFormData.productTag = this.productTag.join();
		  }
		  let formData = new FormData();
		  // 遍历对象进行枚举
		  Object.keys(that.perfectFormData).forEach(function(key) {
		     formData.append(key, that.perfectFormData[key]);
		  });
		  this.$axios({
			  method: 'post',
			  url: 'verifyMember/improveMember',
			  headers: {'Content-Type':'multipart/form-data'},
			  data: formData,
		  }).then(res => {
		  		this.$message({
				  message: this.$t('register.saveLogin'),
				  type: 'success'
				});
				// 1s后跳转登录
				setTimeout(()=>{
					this.$router.push('/login');
				}, 1000);
		  })
		  .catch(err => {});
	  }
  }
}
</script>

<style lang="less" scoped>
	.container{
		background: #f2f5fa;
	}
	.loginContent{
		padding: .6rem 0;
	}
	.loginForm{
		max-width: 500px;
		width: 100%;
		padding-top: .5rem;
		padding-bottom: .5rem;
		border-radius: 0;
		margin: 0 auto;
		.tip{
			margin: .15rem 0 .4rem;
		}
		.goLogin{
			margin-bottom: .2rem;
			a{
				text-decoration: underline;
			}
		}
		dl{
			dd{
				.label{
					margin-bottom: .1rem;
				}
				&:not(:last-child) {
					margin-bottom: .3rem;
				}
				.fmBtn{
					width: 1.1rem;
				}
				.input,.fmBtn{
					border-radius: 0;
				}
				.code .input{
					width: calc(100% - 1.1rem);
				}
				.item{
					width: 48%;
				}
			}
		}
		.rgStep1{
			.submit{
				button{
					width: 48%;
				}
				.back{
					background: #f5f6f8;
					color: #224ed9;
					&:hover{
						box-shadow: 2px 2px 2px rgba(0,0,0,.1);
					}
				}
			}
		}
		.submit{
			margin-top: .4rem;
			p{
				margin-top: .4rem;
				a{
					color: #224ed9;
					padding-bottom: .1rem;
					border-bottom: solid 1px #224ed9;
				}
			}
		}
	}
</style>
